export const AUTHORS_COUNT = 12
